import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/contracHistory/initialState.contractHistory.data';
import {
  getContractHistory as getContractHistoryAPI,
  contractHistoryViewBakup as contractHistoryViewBakupAPI,
  contractReturnToCreate as contractReturnToCreateAPI,
  createSubmitSave as createSubmitSaveAPI,
  getContractHistoryCPI as getContractHistoryCPIAPI,
} from '../../../../apis/contractsAPI';
import { CONTRACT_HISTORY } from '../../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { handlePending, handleRejection } from '../../../../constants';
import { globalDateFormat } from '../../../../utils/common';

// API Call Functions
export const getContractHistory = createAsyncThunkWrapper(
  CONTRACT_HISTORY.GET_CONTRACT_HISTORY,
  getContractHistoryAPI
);

// API Call Functions
export const getContractHistoryCPI = createAsyncThunkWrapper(
  CONTRACT_HISTORY.GET_CONTRACT_HISTORY_CPI,
  getContractHistoryCPIAPI
);



export const contractHistoryViewBakup = createAsyncThunkWrapper(
  CONTRACT_HISTORY.CONTRACT_HISTORY_VIEW_BACKUP,
  contractHistoryViewBakupAPI
);
export const contractReturnToCreate = createAsyncThunkWrapper(
  CONTRACT_HISTORY.CONTRACT_HISTORY_RETURN_CREATE,
  contractReturnToCreateAPI
);

export const createSubmitSave = createAsyncThunkWrapper(
  CONTRACT_HISTORY.CONTRACTS_SUBMIT,
  createSubmitSaveAPI
);

const contractHistorySlice = createSlice({
  name: 'contractHistory',
  initialState,
  reducers: {
    handleReturncreate :(state, action) =>{
      state.returnToCreateModal = action?.payload;
      state.contractHistoryViewForm.comment = '';
    },
    handleModify :(state, action) =>{
      state.isModifyModal = action?.payload;
      state.contractHistoryViewForm.comment = '';
    },
    handleHistoryViewForm: (state, action) => {
      state.contractHistoryViewForm[action.payload.name] =
        action?.payload?.value;
    },
    handleViewBackup:(state, action) =>{
      state.contractViewBackup = action?.payload;
      state.isHistoryViewBackUp = true;
    },
    handleResetVaules : (state) =>{
      state.contractViewBackup = initialState.contractViewBackup;
      state.isHistoryViewBackUp = initialState.isHistoryViewBackUp;
      state.contractReturnTocreate = initialState.contractReturnTocreate;
      state.contractHistoryView = initialState.contractHistoryView;
    },
    handleCreateSubmit :(state, action) =>{
      state.isCreateSubmitModal = action?.payload;
      state.createSubmitViewForm.comment = '';
    },
    handleSubmitViewForm: (state, action) => {
      state.createSubmitViewForm[action?.payload?.name] =
        action?.payload?.value;
    },
    recordSubmitSuccessSet:(state,action)=>{
      state.isRecordSubmitted=action?.payload;
    },
    isFailedSet:(state,action)=>{
      state.isFailed=action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContractHistory.pending, (state) => {
        state.contractHistoryData = [];
        state.isCountryHistoryResults = null;
      })
      .addCase(getContractHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.contractHistoryData = action?.payload
          ? action.payload.contractsCPIHistory
          : [];
        state.contractHistoryTotalCount = action?.payload?.totalRecords
          ? action.payload.totalRecords
          : 0;
        state.isCountryHistoryResults = action?.payload?.country?.length === 0;        
      })
      .addCase(getContractHistory.rejected, (state, action) => {
        handleRejection(state, action);
        state.contractHistoryData = [];
        state.contractHistoryTotalCount = 0;
        state.isCountryHistoryResults = true;
      })

      .addCase(getContractHistoryCPI.pending, (state) => {
        state.contractHistoryCPIData = [];
        state.isCountryHistoryCPIResults = null;
        state.contractHistoryCPITotalCount = 0;
        state.historyCPILoading = true;
      })
      .addCase(getContractHistoryCPI.fulfilled, (state, action) => {
        state.contractHistoryCPIData = action?.payload?.contractsCPIHistory
          ? action?.payload?.contractsCPIHistory?.map((item)=> {
            item.effectiveDate = item?.effectiveDate ? globalDateFormat(item?.effectiveDate) : item.effectiveDate;
            item.cpiPct = item?.cpiPct? item?.cpiPct?.toFixed(2)+'%' : '-';
            return item;
          })
          : [];
          state.isCountryHistoryCPIResults = action?.payload?.length === 0;     
          state.contractHistoryCPITotalCount = action?.payload?.totalRecords || 0;
          state.historyCPILoading = false;
      })
      .addCase(getContractHistoryCPI.rejected, (state, action) => {
        handleRejection(state, action);
        state.contractHistoryCPIData = [];
        state.contractHistoryCPITotalCount = 0;
        state.isCountryHistoryCPIResults = true;
        state.historyCPILoading = false;
      })

      .addCase(contractHistoryViewBakup.pending, handlePending)
      .addCase(contractHistoryViewBakup.fulfilled, (state, action) => {
        state.loading = false;
        state.contractHistoryView = action?.payload? action?.payload : '';
        state.contractHistoryView = 'success';
        state.contractReturnTocreate = '';
      })
      .addCase(contractHistoryViewBakup.rejected, handleRejection)

      .addCase(contractReturnToCreate.pending, handlePending)
      .addCase(contractReturnToCreate?.fulfilled, (state, action) => {
        state.loading = false;
        state.contractReturnTocreate = action?.payload? action?.payload : '';
        state.contractHistoryView = '';
        state.contractReturnTocreate = 'success';
      })
      .addCase(contractReturnToCreate.rejected, handleRejection)

      .addCase(createSubmitSave.pending, (state, action) => {
        handlePending(state, action);
        state.savingCreate = true;
        state.isRecordSubmitted=false;
        state.submitForApprovalSubmitLoader = true;
      })
      .addCase(createSubmitSave.fulfilled, (state, action) => {
        state.savingCreate = false;
        state.savingCreateData = action?.payload? action?.payload : '';
        state.isRecordSubmitted=true;
        state.submitForApprovalSubmitLoader = false;
      })
      .addCase(createSubmitSave.rejected, (state, action) => {
        handleRejection(state, action);
        state.savingCreate = false;
        state.isRecordSubmitted=false;
        state.isFailed=true;
        state.submitForApprovalSubmitLoader = false;
      });
  },
});

export const { handleReturncreate,handleModify, handleHistoryViewForm, handleViewBackup, handleResetVaules,handleCreateSubmit,handleSubmitViewForm,recordSubmitSuccessSet,isFailedSet} = contractHistorySlice.actions;

export default contractHistorySlice.reducer;
